<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>
          Weekly timesheets report for Week {{ week }} {{ year }} starting {{ startDate | tinyDate }}
          <v-btn
              @click="showPicker = true"
              class="float-right"
              small>View calendar</v-btn>
          <v-btn
              @click="changeWeek(2)"
              class="float-right ml-2 mr-2"
              small>Next Week</v-btn>
          <v-btn
              @click="changeWeek(1)"
              class="float-right ml-2"
              small>Prev Week</v-btn>
          <v-btn
            @click="exportTimesheets(true)"
            class="float-right"
            small>
            Export</v-btn>
        </h1>
      </v-col>
    </v-row>
    <v-row v-if="showPicker">
      <v-col>
        <v-date-picker v-model="weekDate"></v-date-picker>
      </v-col>
    </v-row>
    <v-skeleton-loader type="card" v-if="timesheets.length === 0"></v-skeleton-loader>
    <v-row v-else>
      <v-col>
        <v-simple-table
            fixed-header
            height="550px"
        >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Job Number</th>
              <th class="text-left">Notes</th>
              <th class="text-left">Date</th>
              <th class="text-left">End Date</th>
              <th class="text-left">Start Time</th>
              <th class="text-left">End Time</th>
              <th class="text-left">Time Recorded</th>
              <th class="text-left">Checked</th>
              <th class="text-left">Office Notes</th>
              <th style="width: 149px;">&nbsp;</th>
            </tr>
            </thead>
            <tbody
              v-for="(sheet, index) in timesheets"
              :key="index">
              <tr>
                <td colspan="9">{{ sheet.name }}</td>
              </tr>
              <tr
                v-for="(ts, tindex) in sheet.timesheets"
                :key="tindex">
                <td><v-text-field v-model="ts.job_number"/></td>
                <td><v-text-field v-model="ts.notes" /></td>
                <td><v-text-field v-model="ts.prettyDate" /></td>
                <td><v-text-field v-model="ts.prettyEndDate" /></td>
                <td><v-text-field v-model="ts.start_time" /></td>
                <td><v-text-field v-model="ts.end_time" /></td>
                <td><v-text-field v-model="ts.timeRecorded" /></td>
                <td>
                  <v-checkbox @change="toggleChecked(index, tindex)" :ripple="false"  v-model="ts.checked"></v-checkbox>
                </td>
                <td>
                  <v-text-field v-model="ts.office_notes" />
                </td>
                <td>
                  <v-btn
                    x-small
                    color="green"
                    @click="updateTimesheet(index, tindex)">
                    Save
                  </v-btn>
                  &nbsp;
                  <v-btn
                    x-small
                    color="red"
                    @click="confirmDeleteTimesheet(index, tindex)">
                    Delete
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog
        v-model="showConfirmDeleteTimesheet"
        max-width="290"
    >
      <v-card>
        <v-card-text class="pt-4">
          Are you sure you wish to delete this timesheet?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="indexToDelete = -1; tindexToDelete = -1, showConfirmDeleteTimesheet = false"
          >
            Close
          </v-btn>
          <v-btn
              text
              @click="deleteTimesheet"
              color="red">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from '../../../axios';

export default {
  name: 'AdminTimesheetsIndex',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      indexToDelete: -1,
      tindexToDelete: -1,
      timesheets: [],
      showConfirmDeleteTimesheet: false,
      showPicker: false,
      week: 0,
      year: 0,
      weekDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      startDate: null,
    };
  },
  watch: {
    weekDate() {
      this.showPicker = false;
      this.updateWeek();
    },
  },
  methods: {
    exportTimesheets() {
      const day = this.startDate.getDate();
      const month = (this.startDate.getMonth() + 1);
      const year = this.startDate.getFullYear();
      const date = `${year}-${month}-${day}`;
      axios.post(`/spreadsheets/timesheets.json?token=${this.token}`, date, {responseType:'blob'})
          .then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'timesheets.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          });
    },
    getTimesheets() {
      const day = this.startDate.getDate();
      const month = (this.startDate.getMonth() + 1);
      const year = this.startDate.getFullYear();
      const date = `${year}-${month}-${day}`;
      axios.post(`/timesheets/getAll.json?token=${this.token}`, date)
        .then((response) => {
          this.timesheets = response.data.timesheets;
          this.length = response.data.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeWeek(direction) {
      this.timesheets = [];
      if (direction === 1) {
        if (this.week > 1) {
          this.week = parseInt(this.week) - 1;
        } else {
          this.week = 52;
          this.year = parseInt(this.year) - 1;
        }
      } else {
        if (this.week < 52) {
          this.week = parseInt(this.week) + 1;
        } else {
          this.week = 1;
          this.year = parseInt(this.year) + 1;
        }
      }
      const d = (1 + (this.week - 1) * 7);
      const date = new Date(this.year, 0, d);
      this.startDate = this.getMonday(date);
      this.getTimesheets();
    },
    confirmDeleteTimesheet(index, tindex) {
      this.indexToDelete = index;
      this.tindexToDelete = tindex;
      this.showConfirmDeleteTimesheet = true;
    },
    deleteTimesheet() {
      const timesheet = this.timesheets[this.indexToDelete].timesheets[this.tindexToDelete];
      axios.post(`/timesheets/delete/${timesheet.id}.json?token=${this.token}`)
          .then(() => {
            this.timesheets[this.indexToDelete].timesheets.splice(this.tindexToDelete, 1);
          });
    },
    getMonday(d) {
      d = new Date(d);
      let day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    },
    updateTimesheet(index, tindex) {
      const timesheet = this.timesheets[index].timesheets[tindex];
      axios.post(`/timesheets/updateSingle.json?token=${this.token}`, timesheet);
    },
    updateWeek() {
      this.week = this.getWeek(new Date(this.weekDate));
      const currentDate = new Date(this.weekDate);
      this.year = currentDate.getFullYear();
      this.startDate = this.getMonday(currentDate);
      this.getTimesheets();
    },
    getWeek(date) {
      if (!(date instanceof Date)) date = new Date();
      const nDay = (date.getDay() + 6) % 7;
      date.setDate(date.getDate() - nDay + 3);
      const n1stThursday = date.valueOf();
      date.setMonth(0, 1);
      if (date.getDay() !== 4) {
        date.setMonth(0, 1 + ((4 - date.getDay()) + 7) % 7);
      }
      return 1 + Math.ceil((n1stThursday - date) / 604800000);
    },
    toggleChecked(index, tindex) {
      const id = this.timesheets[index].timesheets[tindex].id;
      axios.get(`/timesheets/toggleChecked/${id}.json?token=${this.token}`);
    },
  },
  mounted() {
    this.updateWeek();
  },
};
</script>
